"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LinkStyle = {
    baseStyle: {
        color: 'blue.500',
        textDecoration: 'underline',
        _hover: { color: 'blue.600' },
        _active: { color: 'blue.700' },
    },
};
exports.default = LinkStyle;
